import { render, staticRenderFns } from "./newtagmodel.vue?vue&type=template&id=36217644&scoped=true"
import script from "./newtagmodel.vue?vue&type=script&lang=js"
export * from "./newtagmodel.vue?vue&type=script&lang=js"
import style0 from "./newtagmodel.vue?vue&type=style&index=0&id=36217644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36217644",
  null
  
)

export default component.exports